<ol class="breadcrumb">
  <li>
    <a routerLink="/home">
      <i class="icon-home"></i> Home</a>
    </li>
    <li class="active">To do</li>
  </ol>
  <h1>
    To do
  </h1>
  @if (newReportService.isPwa) {
    <div class="pending-container">
      <h3>Unfinished reports</h3>
    </div>
  }

  @if (newReportService.isPwa) {
    <div>
      <app-table-unfinished-reports [employeeId]="employeeId">unfinished report table here...</app-table-unfinished-reports>
      <h3>To-do reports</h3>
    </div>
  }

  <div>
    @if (profileId == 4) {
      <app-table-todo-reports [employeeId]="employeeId">Todo reports</app-table-todo-reports>
    }
    @if (profileId != 4) {
      <app-table-todo-report [employeeId]="employeeId">Todo reports</app-table-todo-report>
    }
  </div>
